.cnc-page-tabs-separator {
  width: 0;
  align-self: stretch;
  stroke-width: 1px;
  stroke: var(--base-border-strong-default);
  margin: 0 var(--size-xs);
  border-left: 1px solid var(--base-border-strong-default);
}
